import { useMemo } from 'react'
import { format } from 'date-fns'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import useQueryGetPlayerDepositWithdrawGraph from '@/modules/dashboard/api/hooks/useQueryGetPlayerDepositWithdrawGraph'
import DepositWithdrawGraph from '../DepositWithdrawGraph'

interface PlayerDepositWithdrawGraphProps {
	playerId: string
}

export default function PlayerDepositWithdrawGraph({
	playerId,
}: PlayerDepositWithdrawGraphProps) {
	const { dateFilter } = useDateFilter()

	const payload = useMemo(
		() => ({
			playerId,
			startDate: dateFilter.startDate,
			endDate: dateFilter.endDate,
		}),
		[playerId, dateFilter.startDate, dateFilter.endDate],
	)
	const { data, isLoading } = useQueryGetPlayerDepositWithdrawGraph(payload)

	return (
		<div className="space-y-4">
			{/* Header - Mobile Responsive */}
			<div className="flex flex-col gap-4 sm:flex-row sm:justify-between">
				<div className="min-w-0 flex-1">
					<h3 className="truncate text-base font-semibold sm:text-lg">
						ยอดฝาก/ถอน (
						{payload.startDate
							? format(new Date(payload.startDate), 'dd MMM yyyy')
							: 'ทั้งหมด'}
						{payload.endDate
							? ` - ${format(new Date(payload.endDate), 'dd MMM yyyy')}`
							: ''}
						)
					</h3>
					<p className="text-xs text-gray-600 sm:text-sm">
						แสดงข้อมูลยอดฝาก ถอนตามช่วงเวลาที่เลือก
					</p>
				</div>

				{/* Date Controls - Responsive Layout */}
				<div className="flex flex-col gap-3 sm:flex-col sm:items-end sm:gap-4">
					<div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
						<DateRangePicker />
					</div>
					<DateRangeButtons />
				</div>
			</div>

			{/* Graph Component */}
			<div className="w-full overflow-hidden">
				<DepositWithdrawGraph
					data={{ data: data?.data?.graphData || [] }}
					isLoading={isLoading}
					startDate={payload.startDate}
					endDate={payload.endDate}
					hideTitle={true}
					enableSliding={true}
				/>
			</div>
		</div>
	)
}
